import "jquery";
import "appdevresources/jquery-ui";
import "jquery-maskmoney/dist/jquery.maskMoney";
import "bootstrap";
import "popper.js";
import "trumbowyg";
import "appdevresources/toggle-switch";
import "jquery-fullscreen-kayahr";
import "@fortawesome/fontawesome-free/js/all";

console.debug("Loaded library: shared");
